import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastService } from 'src/app/services/toast.service';
import { AccountAuthService } from '../account-auth.service';
import { newPasswordForm } from '../new-password-form';

/** /reset-password?uid=…&token=…  (the link from the "forgot password" email) */
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../auth-form.scss'],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {
  readonly form = newPasswordForm(this.fb);
  state: 'checking' | 'ready' | 'invalid' = 'checking';
  email = '';
  busy = false;
  error: string | null = null;
  passwordError: string | null = null;
  private uid = '';
  private token = '';

  constructor(
    private fb: FormBuilder,
    private auth: AccountAuthService,
    private route: ActivatedRoute,
    private router: Router,
    private toasts: ToastService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    this.uid = params.get('uid') || '';
    this.token = params.get('token') || '';
    // Keep the link out of the address bar and history once read.
    this.router.navigate([], { queryParams: {}, replaceUrl: true });
    this.form.controls.password.valueChanges.subscribe(() => (this.passwordError = null));

    if (!this.uid || !this.token) {
      this.state = 'invalid';
      return;
    }
    this.auth.checkResetLink(this.uid, this.token).subscribe({
      next: (res) => {
        this.email = res.email;
        this.state = 'ready';
        this.cdr.detectChanges();
      },
      error: (err) => {
        const error = this.auth.toError(err);
        this.state = error.code === 'link_invalid' ? 'invalid' : 'ready';
        if (this.state === 'ready') this.error = error.message;
        this.cdr.detectChanges();
      },
    });
  }

  submit(): void {
    if (this.busy) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.busy = true;
    this.error = null;
    this.auth.resetPassword(this.uid, this.token, this.form.controls.password.value!).subscribe({
      next: (session) => {
        this.toasts.showSuccess('Your password has been changed.', 'success');
        this.auth.startSession(session).catch(() => this.router.navigate(['/login']));
      },
      error: (err) => {
        this.busy = false;
        const error = this.auth.toError(err);
        if (error.code === 'weak_password') this.passwordError = error.message;
        else if (error.code === 'link_invalid') this.state = 'invalid';
        else this.error = error.message;
        this.cdr.detectChanges();
      },
    });
  }
}
